import { useState } from 'react';
import { animated, useTransition } from '@react-spring/web';
import { OrderProductFooter } from './OrderProductFooter';
import { getOrderTotalAmount } from 'components/LightConversation/utils/order';
import { OrderProductListItem } from './OrderProductListItem';

interface OrderProductListProps {
  conversationId?: string;
  order: Conversation.Trade.Vo;
  products: Conversation.Trade.Product[];
  orderTotalAmount?: number;
  defaultShowCount?: number;
  simple?: boolean;
  showTotalAmount?: boolean;
  leChatStatus?: Conversation.Trade.LeChatLogisticsStatus;
  returnedItemIds?: string[];
  showComment?: boolean;
  isDetail?: boolean;
}

export const OrderProductList = (props: OrderProductListProps) => {
  const {
    conversationId,
    order,
    products,
    leChatStatus,
    defaultShowCount = 1,
    simple,
    showTotalAmount = true,
    returnedItemIds,
    showComment = false,
    isDetail,
  } = props;
  const [showMore, setShowMore] = useState(false);

  const orderTotalAmount = showTotalAmount ? getOrderTotalAmount(order) : undefined;

  const firstProduct = products.slice(0, defaultShowCount);
  const moreProducts = products.slice(defaultShowCount);
  const hasMoreProducts = moreProducts.length > 0;

  const transition = useTransition(showMore, {
    from: { height: 0, opacity: 0, transform: 'translate3d(0,-10px,0)' },
    enter: { height: 'auto', opacity: 1, transform: 'translate3d(0,0px,0)' },
    leave: { height: 0, opacity: 0, transform: 'translate3d(0,-10px,0)' },
    config: { tension: 300, friction: 30 },
  });

  const handleToggle = () => {
    setShowMore((prev) => !prev);
  };

  return (
    <div className="py-3 flex flex-col">
      {/* 首条始终展示 */}
      {firstProduct.map((product, index) => {
        return (
          <OrderProductListItem
            key={index}
            conversationId={conversationId}
            order={order}
            product={product}
            simple={simple}
            className={index === 0 ? '' : 'mt-[12px]'}
            leChatStatus={leChatStatus}
            returnedItemIds={returnedItemIds}
            showComment={showComment}
            isDetail={isDetail}
          />
        );
      })}
      {/* 更多商品：仅 restVisible 时挂载，用 react-spring 做高度折叠动画 */}
      {transition(
        (style, item) =>
          item && (
            <animated.div className="overflow-hidden" style={style}>
              {moreProducts.map((product, index) => {
                return (
                  <OrderProductListItem
                    key={index}
                    conversationId={conversationId}
                    order={order}
                    product={product}
                    simple={simple}
                    className="mt-[12px]"
                    leChatStatus={leChatStatus}
                    returnedItemIds={returnedItemIds}
                    showComment={showComment}
                  />
                );
              })}
            </animated.div>
          ),
      )}
      <OrderProductFooter
        hasMore={hasMoreProducts}
        showMore={showMore}
        total={products.length}
        unit={order.unit}
        showTotalAmount={showTotalAmount}
        orderTotalAmount={orderTotalAmount}
        onToggle={handleToggle}
      />
    </div>
  );
};
